// Tracks Vue mounts created from placeholder DOM nodes so they can be destroyed
// later by placeholder or by any removed DOM subtree during Turbo updates.
export default function createVueMountRegistry() {
  const byPlaceholder = new WeakMap();
  const entries = new Set();

  const destroyEntry = (entry) => {
    if (!entry) {
      return;
    }

    entry.app.$destroy();
    byPlaceholder.delete(entry.placeholder);
    entries.delete(entry);
  };

  return {
    has(placeholder) {
      return byPlaceholder.has(placeholder);
    },
    set({ placeholder, root, app }) {
      const entry = { placeholder, root, app };

      byPlaceholder.set(placeholder, entry);
      entries.add(entry);
    },
    destroyInSubtree(root) {
      if (!root) {
        return;
      }

      const entriesToDestroy = [];

      entries.forEach((entry) => {
        const inPlaceholderSubtree = root === entry.placeholder || root.contains?.(entry.placeholder);
        const inRootSubtree = root === entry.root || root.contains?.(entry.root);

        if (inPlaceholderSubtree || inRootSubtree) {
          entriesToDestroy.push(entry);
        }
      });

      entriesToDestroy.forEach(destroyEntry);
    },
  };
}
